import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  BaseOneResponseInterface,
  BulkResponseDataInterface,
  GetManyResponseInterface,
} from '../../../../shared/model/interface/crud-response-interface.model';

@Injectable({
  providedIn: 'root',
})
export class TagLoggerService {
  private readonly routes = {
    tagLogger: `${this.baseUrl}/opc-tag-automation-settings/tag-logger`,
  };

  constructor(public http: HttpClient, @Inject('API_BASE_URL') private readonly baseUrl: string) {}

  public getData(params: HttpParams): Observable<GetManyResponseInterface<any>> {
    return this.http.get<GetManyResponseInterface<any>>(this.routes.tagLogger, {
      params,
    });
  }

  public getOne(recordId: number, params?: HttpParams): Observable<BaseOneResponseInterface<any>> {
    return this.http.get<BaseOneResponseInterface<any>>(`${this.routes.tagLogger}/${recordId}`, {
      params,
    });
  }

  public addOne(record: any): Observable<BaseOneResponseInterface<any>> {
    return this.http.post<BaseOneResponseInterface<any>>(`${this.routes.tagLogger}`, record);
  }

  public editOne(recordId: number, record: any): Observable<BaseOneResponseInterface<any>> {
    return this.http.patch<BaseOneResponseInterface<any>>(`${this.routes.tagLogger}/${recordId}`, record);
  }

  public deleteOnes(recordIds: number[]): Observable<BulkResponseDataInterface> {
    if (recordIds.length > 1) {
      const httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        body: {
          tagLoggerIds: recordIds,
        },
      };
      return this.http.delete<BulkResponseDataInterface>(`${this.routes.tagLogger}/bulk/delete`, httpOptions);
    }
    return this.http.delete<BulkResponseDataInterface>(`${this.routes.tagLogger}/${recordIds[0]}`);
  }
}
